// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1988":"4c77af2f445225bf","6808":"b4b15eebf43bec1a","9514":"a7f4b4988d0c5ad8"}[chunkId] + ".js";
};